import { Route, Routes, RoutesProps } from 'react-router-dom'

import { userRoutes } from './userRoutes'
import { RouteDefinition } from '../../utils/type'
import { LoadingAnimation } from '../../components/ProcessingModal/Animation'

export interface User {
  id: string
}

interface Props {
  initialLoad: boolean
}

function getRouteRenderWithAuth(route: RouteDefinition) {
  const RouteComponent = route.requires
    ? route.requires(route.element)
    : route.element
  return { element: <RouteComponent /> }
}

export const RoutesComponent: React.FC<Props & RoutesProps> = (props) => {
  // const userLoggedIn = Boolean(getLocalJwt())
  // const { userLoggedIn } = useAppSelector((state) => state.loginReducer)

  if (props.initialLoad) return <LoadingAnimation />

  const mapRoutes = (route: RouteDefinition, i: number) => {
    const render = getRouteRenderWithAuth(route)
    return <Route key={i} path={route.path} {...render} />
  }
  return <Routes>{userRoutes.map(mapRoutes)}</Routes>
}
